import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Pergunta } from './pergunta';
import { CategoriaPergunta } from './categoria-pergunta';
import { OpcaoGenerica } from './opcao-generica';
import { Question } from './question';



export class QuestionModel{
    questions: any = [];

    public carregaForm(categorias: CategoriaPergunta[], ehFiltro: boolean): FormGroup {
      let form : FormGroup;
      for(let categoria of categorias){
          if(categoria.perguntas){
            this.carregaPergunta(categoria.perguntas, categoria, ehFiltro);
          }
      }

      if(ehFiltro){
        this.carregaFiltroPadrao();
      }

      // ordenand
      this.questions.sort((a: any,b: any) => a.order - b.order);
      // se jah existe o form, entao eu reseto e preencho resposta (se existir)
      form = this.toGroup(ehFiltro);
      form= this.desabilitaCampos(form);
      return form;
    }


    public carregaFiltroPadrao(){
      let filtro:Pergunta = new Pergunta();
      filtro.id = 999999;
      filtro.enunciado = "Usuário";
      filtro.obrigatoria = false;
      filtro.ordem = 0;
      this.incluiCampo(filtro,  filtro.opcoesGenericas, "textbox", true );

      filtro = new Pergunta();
      filtro.id = 999998;
      filtro.enunciado = "Data de Criação";
      filtro.obrigatoria = false;
      filtro.ordem = 0;
      this.incluiCampo(filtro,  filtro.opcoesGenericas, "data", true );
    }

    public carregaPergunta (perguntas:Pergunta[], categoria:CategoriaPergunta, ehFiltro: boolean){
      for(let pergunta of perguntas){
          switch(pergunta.tipoResposta){
            case 0:
              this.incluiCampo(pergunta, pergunta.opcoesGenericas, "radio", ehFiltro);
              break;
            case 1:
              this.incluiCampo(pergunta, pergunta.opcoesGenericas, "select-multiple", ehFiltro );
              break;
            case 2:
              this.incluiCampo(pergunta,  pergunta.opcoesGenericas, "textbox", ehFiltro );
              break;
            case 3:
              this.incluiCampo(pergunta,  pergunta.opcoesGenericas, "textarea", ehFiltro );
              break;
            case 4:
              this.incluiCampo(pergunta, pergunta.opcoesGenericas, "dropdown", ehFiltro );
              break;
            case 5:
              this.incluiCampo(pergunta,  pergunta.opcoesGenericas, "data", ehFiltro );
              break;
            case 6:
              this.incluiCampo(pergunta,  pergunta.opcoesGenericas, "inteiro", ehFiltro );
              break;
            case 7:
              this.incluiCampo(pergunta,  pergunta.opcoesGenericas, "decimal", ehFiltro );
              break;
            case 8:
              this.incluiCampo(pergunta,  pergunta.opcoesGenericas, "divisor", ehFiltro );
              break;
            case 9:
              this.incluiCampo(pergunta,  pergunta.opcoesGenericas, "arquivo", ehFiltro );
              break;
          }
        }
    }

    public incluiCampo(pergunta:Pergunta, opcoes:OpcaoGenerica[], controlType: string, ehFiltro: boolean){
      let question = new Question();
       question.key =  pergunta.id;
       question.text = pergunta.enunciado;
       question.alerta = pergunta.alerta;
       question.required = pergunta.obrigatoria;
       question.order = pergunta.ordem;
       question.idCategoria= pergunta.categoria;
       question.style= {
        'background-color':pergunta.backgroundColor
        }

       if(pergunta.obrigatoria && !ehFiltro){
         question.text += " *";
       }


       if(pergunta.respostaBloqueada){
         question.disable= pergunta.respostaBloqueada;
       }

       if( pergunta.instrucao != null &&  pergunta.instrucao.length > 0){
         question.tooltip= pergunta.instrucao;
       }

       // para garantir que somente o textbox e o textarea tenham limite setado
       if(controlType == 'textbox' || controlType == 'textarea'){
         if(pergunta.tamanhoMaximo){
           question.limitMax= pergunta.tamanhoMaximo;
         }
         if(pergunta.tamanhoMinimo){
           question.limitMin= pergunta.tamanhoMinimo;
         }
       }
       // isso define a qtd máxima de aqruivos que o usuário pode fazer o upload
       if(controlType == 'arquivo'){
         question.limitMax= pergunta.tamanhoMaximo;
       }

       if(pergunta.perguntaVinculada){
         question.perguntaVinculada = pergunta.perguntaVinculada;
       }

       if(opcoes){
         question.options = opcoes;
       }
       question.controlType= controlType;

       this.questions.push(question);
    }

     toGroup(ehFiltro: boolean){
        let group:any = {};
        this.questions.forEach((question: any) => {
            if(question.required != null && question.required == true  && !ehFiltro){
              // se tiver limite, entao eu coloco no controlador
              if ((question.limitMin && question.limitMin > 0) && (question.limitMax && question.limitMax > 0)){
                group[question.key] = new FormControl('', Validators.compose([Validators.required, Validators.minLength(question.limitMin), Validators.maxLength(question.limitMax)]));
              }else if(question.limitMin && question.limitMin > 0){
                group[question.key] = new FormControl('', Validators.compose([Validators.required, Validators.minLength(question.limitMin)]));
              }else if(question.limitMax && question.limitMax > 0){
                group[question.key] = new FormControl('', Validators.compose([Validators.required, Validators.maxLength(question.limitMax)]));
              }else{
                // Aqui tenho q ver se eh arquivo, pq se for, entao nao pode ser obrigatorio(eh um bug do angular2)
                // depois eu faco a validacao na mao
                if(question.controlType == "arquivo"){
                  group[question.key] = new FormControl('');
                }else{
                  group[question.key] = new FormControl('', Validators.required);
                }
              }
            }
            else{
              // se tiver limite, entao eu coloco no controlador
              if ((question.limitMin && question.limitMin > 0) &&  (question.limitMax && question.limitMax > 0)){
                group[question.key] = new FormControl('', Validators.compose([Validators.minLength(question.limitMin), Validators.maxLength(question.limitMax)]));
              }else if(question.limitMin && question.limitMin > 0){
                group[question.key] = new FormControl('', Validators.minLength(question.limitMin));
              }else if(question.limitMax && question.limitMax > 0){
                group[question.key] = new FormControl('', Validators.maxLength(question.limitMax));
              }else{
                group[question.key] = new FormControl('');
              }
            }
        });
        return new FormGroup(group);
    }

    desabilitaCampos(form: any){
      this.questions.forEach((question: any) => {
        if(question.disable){
            form.controls[question.key].disable();
        }
      });
      return form;
    }

}
